import { render, staticRenderFns } from "./PresenterDj.vue?vue&type=template&id=6b89a00a&scoped=true"
import script from "./PresenterDj.vue?vue&type=script&lang=js"
export * from "./PresenterDj.vue?vue&type=script&lang=js"
import style0 from "./PresenterDj.vue?vue&type=style&index=0&id=6b89a00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89a00a",
  null
  
)

export default component.exports